import React from 'react';
import PropTypes from 'prop-types';
import { withStructureContext } from '@Components/Results/structure/StructureContext';
import StructureToolbarZoomComponent from '@Components/Results/structure/StructureToolbarZoom';
import ShoppingCart from '@Components/Results/structure/availability/ShoppingCart';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import { contextFromMetadata } from '@Components/Results/utils/metadata';
import StructureToolbarOptionsComponentLegacyContext from '@Components/Results/structure/StructureToolbarOptionsContext';
import { StructureToolbarOptionType, StructureToolbarContextMenuOptions } from '@Pages/RetroSynthesis/components/RsStructure/constants';
import SubstanceDetails from '@Components/Results/structure/substance-details/SubstanceDetails';
import { TooltipConstants } from '@Components/Tooltip';
import UserDatabases from '@Services/UserDatabases';
import StructureToolbarCustomerIcon from '@Components/Results/structure/StructureToolbarCustomerIcon';
import { isCustomerIconVisible } from '@Components/Results/structure/structure-utils';

/* eslint-disable react/destructuring-assignment */
class RsStructureToolbar extends React.Component {
  optionsAvailable() {
    const markushRef = get(this.props, 'structure.details.markushRef');
    const markushStr = !!get(this.props, 'structure.details.markushStr');
    const isMolImagePropertyPresent = !!get(this.props, 'structure.molImage.path');
    const isStructuredSubstance = !!get(this.props, 'structure.molImage.structure');

    return (isMolImagePropertyPresent && isStructuredSubstance) || parseInt(markushRef, 10) > 0 || isStructuredSubstance || markushStr;
  }

  render() {
    const { availability, molImage, supplierNumber, customerInfo } = get(this.props, 'structure');
    const isMolImagePropertyPresent = molImage && molImage.path;
    const isMolImageStructurePresent = get(molImage, 'structure');
    const optionsAvailable = this.optionsAvailable();
    const trackingContext = contextFromMetadata(get(this.props, 'metadata'));
    const { synthesisMenuOptions, trackingContent } = this.props;
    const rxn = get(this.props, 'structure.rxn', null);
    const details = get(this.props, 'structure.details', null);
    const databaseId = get(this.props, 'structure.databaseId', null);
    const viewDetailsEnabled = !isNil(rxn) && !isNil(details) && !isNil(databaseId) && UserDatabases.isDefaultDatabase(databaseId);
    const tooltipId = TooltipConstants.ids.RetrosynthesisStructureIcon;
    const showCustomerIcon = isCustomerIconVisible(customerInfo);
    return (
      <div className="structure-options-bottom">
        {showCustomerIcon ? (
          <div className="structure-options-item--wrapper">
            <StructureToolbarCustomerIcon customerInfo={customerInfo} structure={isMolImageStructurePresent} />
          </div>
        ) : null}

        {!isMolImagePropertyPresent ? null : (
          <div className="structure-options-item--wrapper">
            {availability ? (
              <ShoppingCart
                tooltipId={tooltipId}
                supplierNumber={supplierNumber}
                availability={availability}
                structure={get(this.props, 'structure')}
                trackingContext={trackingContext}
                trackingContent={trackingContent}
                onOpen={() => this.props.onOptionOpen({ type: StructureToolbarOptionType.SHOPPING_CART })}
                onOptionClick={this.props.onShoppingCartOptionClick}
                allowCommercialDBOnly
              />
            ) : null}
          </div>
        )}

        {!this.props.showZoom || !isMolImagePropertyPresent || !isMolImageStructurePresent ? null : (
          <div className="structure-options-item--wrapper">
            <StructureToolbarZoomComponent
              tooltipId={tooltipId}
              heatmapMode={false}
              onOpen={() => this.props.onOptionOpen({ type: StructureToolbarOptionType.ZOOM })}
            />
          </div>
        )}

        {this.props.showDetails && viewDetailsEnabled && (
          <div className="structure-options-item--wrapper">
            <SubstanceDetails
              tooltipId={tooltipId}
              structure={get(this.props, 'structure')}
              reactionId={rxn}
              trackingContext={trackingContext}
              trackingContent={trackingContent}
            />
          </div>
        )}

        {this.props.showOptions && optionsAvailable && (
          <div className="structure-options-item--wrapper">
            <StructureToolbarOptionsComponentLegacyContext
              allowedOptionsItems={StructureToolbarContextMenuOptions.allowed}
              tooltipId={tooltipId}
              optionsIcon="#icon-ellipsis"
              synthesisOptions={synthesisMenuOptions}
              trackingContext={trackingContext}
              onOpen={() => this.props.onOptionOpen({ type: StructureToolbarOptionType.OPTIONS })}
              onItemClick={(type) => this.props.onMenuItemClick({ type })}
              onOpenInDatabaseOptionClick={(option) => this.props.onOpenInDatabaseClick({ option })}
              onAutoSynthesizeOptionClick={this.props.onAutoSynthesizeClick}
            />
          </div>
        )}
      </div>
    );
  }
}

RsStructureToolbar.defaultProps = {
  onOptionOpen: () => null,
  onMenuItemClick: () => null,
  onOpenInDatabaseClick: () => null,
  onAutoSynthesizeClick: () => null,
  onShoppingCartOptionClick: () => null,
  showOptions: true,
  showZoom: true,
  showDetails: true,
};

RsStructureToolbar.propTypes = {
  synthesisMenuOptions: PropTypes.array,
  onOptionOpen: PropTypes.func,
  onMenuItemClick: PropTypes.func,
  onOpenInDatabaseClick: PropTypes.func,
  onAutoSynthesizeClick: PropTypes.func,
  onShoppingCartOptionClick: PropTypes.func,
  showZoom: PropTypes.bool,
  showOptions: PropTypes.bool,
  showDetails: PropTypes.bool,
  trackingContent: PropTypes.array,
};

export default withStructureContext(RsStructureToolbar);
